module.exports = __webpack_public_path__ + "static/media/ill_ryggont.b18aa87a.svg";